import { useEffect, useLayoutEffect, useRef } from 'react'

const BOTTOM_THRESHOLD = 120

export const useAutoScroll = (deps = []) => {
  const containerRef = useRef(null)
  const isUserLockedRef = useRef(false)

  useEffect(() => {
    const container = containerRef.current
    if (!container) return

    const handleScroll = () => {
      const distanceToBottom =
        container.scrollHeight - (container.scrollTop + container.clientHeight)

      isUserLockedRef.current = distanceToBottom > BOTTOM_THRESHOLD
    }

    container.addEventListener('scroll', handleScroll, { passive: true })
    handleScroll()

    return () => container.removeEventListener('scroll', handleScroll)
  }, [])

  useLayoutEffect(() => {
    const container = containerRef.current
    if (!container || isUserLockedRef.current) return

    container.scrollTo({
      top: container.scrollHeight,
      behavior: 'smooth'
    })
  }, deps)

  return containerRef
}
